import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import {
  getScreeningVendor,
  submitCreditScreening,
} from "../../services/AdminDashService";
import { ScreeningVendor } from "src/types/Applicant";

const SubmitCreditScreeningModal = (props) => {
  const dispatch = useAppDispatch();
  const notification = useAppSelector(
    (state) => state.applications.notification
  );
  const { showModal, setShowModal, applicant, applicationId } = props;
  const screeningVendor = getScreeningVendor(applicant);
  const canSubmit = !!applicant && !!applicationId;
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    if (
      notification &&
      notification.type === "INFO" &&
      notification.message?.includes("Credit Screening for")
    ) {
      window.localStorage.setItem("REFRESH_APPS", Math.random().toString());
      resetModal();
      window.scrollTo(0, 0);
    } else if (
      notification &&
      notification.type === "ERROR" &&
      notification.message
    ) {
      resetModal();
    }
  }, [notification]);

  const runCredit = () => {
    if (!canSubmit) return;

    setDisableSubmit(true);
    setShowSpinner(true);
    dispatch(
      submitCreditScreening(
        applicationId,
        applicant.id,
        `${applicant.firstName} ${applicant.lastName}`,
        applicant
      )
    );
  };

  const resetModal = () => {
    setShowModal(false);
    setShowSpinner(false);
    setDisableSubmit(false);
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showModal}
      className="submit-credit-modal"
    >
      <Modal.Header className="border-bottom">
        <Modal.Title>{`Submit ${screeningVendor} Credit Screening`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="details block-labels mt-0">
          <div className="subtitle">
            {`Do you want to submit the ${screeningVendor} credit screening again?`}
          </div>
          <div className="subtitle">
            {screeningVendor === ScreeningVendor.TRANSUNION
              ? "This will re-submit screening through TransUnion."
              : "This will re-submit screening through First Advantage (FADV)."}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top">
        <Button
          className="cancel-btn"
          variant="secondary"
          onClick={() => setShowModal(false)}
          disabled={disableSubmit}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => runCredit()}
          disabled={disableSubmit || !canSubmit}
        >
          {showSpinner && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
          )}

          {showSpinner
            ? "Loading..."
            : `Run ${screeningVendor} Credit Screening`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubmitCreditScreeningModal;
